import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'

Vue.use(VueClipboard)

const HelloJs = require('hellojs/dist/hello.all.min.js')
const VueHello = require('vue-hellojs')

HelloJs.init({
		facebook: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
		google: process.env.VUE_APP_GOOGLE_CLIENT_ID
	},
	{
		redirect_uri: 'https://meagur.com/'
	}
)

Vue.use(VueHello, HelloJs)

Vue.config.productionTip = false

axios.all([ store.dispatch('attemptRefresh'), store.dispatch('getLeagues') ])
	.finally(() => {
		store.commit('HTTP_FINISHED')
		new Vue({
			router,
			store,
			render: h => h(App)
		}).$mount('#app')
	})
